import { Component, Input } from '@angular/core';
import { ToggleGroupItem } from '../se-text-editor/menu/toggle-group-item';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'se-text-editor-menu-toggle-group',
    templateUrl: './se-text-editor-menu-toggle-group.component.html',
    styleUrls: ['./se-text-editor-menu-toggle-group.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: SeTextEditorMenuToggleGroupComponent,
        multi: true
    }]
})
export class SeTextEditorMenuToggleGroupComponent implements ControlValueAccessor {
    @Input() items: ToggleGroupItem[];
    @Input() multiple: boolean;

    disabled: boolean;
    value: any;

    private onChangeFn: any;

    onToggleButtonChange(event: MatButtonToggleChange) {
        this.onChangeFn(event.value);
    }

    // ControlValueAccessor implementation.

    writeValue(obj: any): void {
        this.value = obj;
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        // vuota
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
